const quizKitCustomerCompletions = JSON.parse(localStorage.getItem('quizKitCustomerCompletions') || 'null');
if (quizKitCustomerCompletions && quizKitCustomerCompletions['RktUepVsDft']) {
  const btn = $('a:not(".btn-retake")[href="https://www.dphue.com/pages/dphue-hair-quiz"]');
  btn.text(quizKitCustomerCompletions['RktUepVsDft'].personalization?.label || 'My matches');
  btn.attr('href', 'https://www.dphue.com/pages/hair-quiz-result');
}
if (quizKitCustomerCompletions && quizKitCustomerCompletions['0uPhDQ29Otg']) {
  const btn = $('a:not(".btn-retake")[href="https://www.dphue.com/pages/gloss-shade-finder"]');
  btn.text(quizKitCustomerCompletions['0uPhDQ29Otg'].personalization?.label || 'My matches');
  btn.attr('href', 'https://www.dphue.com/pages/hair-quiz-result-2');
}

if (quizKitCustomerCompletions && quizKitCustomerCompletions['skm38qusVZ']) {
  const btn = $('a:not(".btn-retake")[href="https://www.dphue.com/pages/acv-mini-quiz-2"]');
  btn.text(quizKitCustomerCompletions['skm38qusVZ'].personalization?.label || 'My matches');
  btn.attr('href', 'https://www.dphue.com/pages/hair-quiz-result-3');
}

if (quizKitCustomerCompletions && quizKitCustomerCompletions['92HsSASQW']) {
  const btn = $('a.link-back[href="#quiz-kit-key-92HsSASQW"]');
  btn.text(quizKitCustomerCompletions['92HsSASQW'].personalization?.label || 'Back');
  btn.attr('href', 'https://dphue.com/pages/ulta-gloss-and-glossy-glaze-shade-finder-1');

  const btn_retake = $('a.btn-retake-2[href="#quiz-kit-key-92HsSASQW"]');
  btn_retake.text(quizKitCustomerCompletions['92HsSASQW'].personalization?.label || 'Retake a quiz');
  btn_retake.attr('href', 'https://dphue.com/pages/ulta-gloss-and-glossy-glaze-shade-finder-1');
}